import { FC, MouseEvent, useCallback, useEffect } from 'react';
import { AppLink } from 'components/core/link/Link';
import { Text } from 'components/core/text';
import { H5 } from 'components/core/text/Text';
import { FCWithChildren } from 'helpers/types/FCWithChildren';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

export const ErrorPage: FC<FallbackProps> = ({ error }) => {
  useEffect(() => {
    if (REACT_APP_STAGE !== 'production') {
      console?.error(error);
    }
  }, [error]);

  const refreshPage = useCallback((e: MouseEvent) => {
    e.preventDefault();

    window.location.reload();
  }, []);

  return (
    <div className="flex flex-col gap-4 p-8">
      <H5>Something went wrong.</H5>
      <Text>
        We&apos;re sorry about that. We&apos;ve alerted our team of the issue.
      </Text>
      <Text>
        In the meantime, try{' '}
        <AppLink
          className="text-primary"
          to=""
          aria-label="click to refresh"
          onClick={refreshPage}
        >
          <strong>refreshing</strong>
        </AppLink>{' '}
        the page
      </Text>
    </div>
  );
};

const logError = (error: Error, info: { componentStack: string }) => {
  console?.error('ErrorBoundary Error:', error);
  console?.error('ErrorBoundary Component Stack:', info?.componentStack);
};

export const AppErrorBoundary: FCWithChildren<{}> = ({ children }) => (
  <ErrorBoundary FallbackComponent={ErrorPage} onError={logError}>
    {children}
  </ErrorBoundary>
);
